
<template>
   <div>
    <section style="background-color: #fff; padding: 40px;">
        <div style="text-align: center;">
        <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold;">{{ block.title }}</h2>
        <img src="/img/teal-line.svg" class="mb20 mt20"/>
    </div>
    <div class="fort-body">
      <table
      v-for="(block, index) in block.Month"
      class="table-striped table-bordered"
      style="display: table; width: 100%; border: none; margin-bottom: 40px; font-family: Figtree, sans-serif !important;"
      :key="index"
                    >
                      <thead :style="{ background: index < 2 ? '#00B4B4' : '#8B8989', color: '#fff', padding: '10px 0 10px 10px' }">
                        <tr>
                          <th
                            scope="col"
                            class="ten"
                        
                           
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span style="font-size: 24px; font-weight: bold; padding: 10px;">{{ block.title }}</span>
                             
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="ten"
                           
                          >
                            <span style="display: flex; flex: 0 0 100%">
                             
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="twenty"
                           
                          >
                            <span style="display: flex; flex: 0 0 100%">
                             
                            </span>
                          </th>                      
                        </tr>
                      </thead>

                      <tbody style="font-size: 16px; font-family: Figtree, sans-serif !important;">
                     
                        <tr
                          scope="row"
                          v-bind:key="index"
                          v-for="(block, index) in block.DateList"
                        >
                          <td style="font-size: 16px; padding: 10px!important;">{{block.date}}</td>
                          <td style="font-size: 16px; padding: 10px;">{{block.title}}</td>
                          <td style="font-size: 16px; padding: 10px;" v-html="block.description"></td>
                         

                 
                        </tr>
                      </tbody>
                    </table>
</div>
    </section>
   
   <divider v-if="block.BottomDivider" />
  </div>
</template>
  
  <script>
  import Divider from "@/components/FortBuilder/Divider.vue";

export default {
  name: "NewsToKnow",
  data() {
    return {
      news:[
        {
          month: "June",
          year: "2025",
          dates: [
            {
              date: "June 2-3",
              title: "Tradeshow",
              desc: "Athletic Equipment Managers Association (AEMA) | Las Vegas, NV"
            },
            {
              date: "June 10-11",
              title: "On-Site Training",
              desc: "Product School"
            },
          ]
        },
        {
          month: "July",
          year: "2025",
          dates: [
            {
              date: "June 4",
              title: "Spacesaver Closed",
              desc: "Holiday"
            },
            {
              date: "June 25",
              title: "Conference Call",
              desc: "Public Safety Market Call, 11:30 AM CDT"
            },
          ]
        },
        {
          month: "August",
          year: "2025",
          dates: [
            {
              date: "August 11-15",
              title: "On-Site Training",
              desc: "Level 2 Installation Training"
            },
            {
              date: "August 22",
              title: "Conference Call",
              desc: "Education & Libraries Market Call, 11:30 AM CDT"
            },
          ]
        }
      ]
    };
  },
  props: {
      block: {
        type: Object,
        required: true,
      },
  },
  components: {
    Divider,
  },
};
</script>
  
  <style scoped>
  table  th {
    border: none;
}
</style>















